
import { Component, Vue, Prop } from 'vue-property-decorator'
import { periodTypeList, formatDate, formatDateTime } from './../../index'
import { handleFill } from '@/utils/util'

@Component
class ConfigBasicInfo extends Vue {
  @Prop({ default: () => ({}) }) formData!: any

  handleFill = handleFill

  get isOnce() {
    return Number(this.formData.periodType) === 1
  }

  get displaySQ() {
    return this.isOnce ? '' : '首期'
  }

  get periodTypeTips() {
    const addTimeText =
      Number(this.formData.periodType) == 2 ? ' 7 天' : ' 1 月'
    return `活动为${this.periodTypeLabel}活动，后续每一期的的统计日期和抽奖时间将在本期基础上加${addTimeText}。`
  }

  // 获取周期类型标签
  get periodTypeLabel() {
    const { periodType = 1 } = this.formData
    const item = periodTypeList.find((p) => p.value === Number(periodType))
    return item.label || '--'
  }

  // 统计日期文本
  get statisticsTimeText() {
    const { statisticsStartTime = '', statisticsEndTime = '' } = this.formData
    if (!statisticsStartTime || !statisticsEndTime) return '--'
    return `${formatDate(statisticsStartTime)} 至 ${formatDate(
      statisticsEndTime
    )}`
  }

  // 抽奖时间文本
  get lotteryTimeText() {
    const { lotteryStartTime = '', lotteryEndTime = '' } = this.formData

    if (!lotteryStartTime || !lotteryEndTime) return '--'
    return `<div>${formatDateTime(lotteryStartTime)}
    至 </div><div>${formatDateTime(lotteryEndTime)}</div>`
  }
}
export default ConfigBasicInfo
